<template>
    <div class="address-input container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Adresse</label>
                    <mapbox-address-autofill
                        ref="autofill"
                        :access-token="accessToken"
                        language="fr"
                        @retrieve="onAddressSelected"
                    >
                        <input class="form-control" type="text" :name="namesPrefix + '_auto'" autocomplete="address-line1" v-model.trim="addressLine1">
                        <input type="hidden" :name="namesPrefix + '_part1'" v-model.trim="addressLine1">
                    </mapbox-address-autofill>
                </div>
                <div v-show="addressSelected">
                    <div class="form-group">
                        <label>Complément</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_part2'" autocomplete="address-line2" v-model.trim="addressLine2">
                    </div>
                    <div class="form-group">
                        <label>Code postal / ZIP</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_zip'" autocomplete="postal-code" v-model.trim="zipCode">
                    </div>
                    <div class="form-group">
                        <label>Ville</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_town'" autocomplete="address-level2" v-model.trim="town">
                    </div>
                    <div class="form-group">
                        <label>Région / Etat</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_state'" autocomplete="address-level1" v-model.trim="state">
                    </div>
                    <div class="form-group">
                        <label>Pays</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_countryname'" autocomplete="country-name" v-model.trim="country">
                    </div>
                    <div class="form-group">
                        <label>Code pays</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_countrycode'" autocomplete="country" v-model.trim="countryCode" :aria-describedby="namesPrefix + '_countrycodeHelpBlock'">
                        <small :id="namesPrefix + '_countrycodeHelpBlock'" class="form-text">
                            <i class="fad fa-question-circle"></i> Exemple: <strong>fr</strong> pour France, <strong>be</strong> pour Belgique, <strong>ch</strong> pour la Suisse
                        </small>
                    </div>
                    <div class="form-group">
                        <label>Longitude</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_lng'" v-model.trim="longitude">
                    </div>
                    <div class="form-group">
                        <label>Latitude</label>
                        <input class="form-control" type="text" :name="namesPrefix + '_lat'" v-model.trim="latitude">
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div v-show="addressSelected">
                    <div ref="minimap" class="minimap"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {MapboxAddressMinimap} from '@mapbox/search-js-web';

export default {
    name: "AddressInput",

    props: {
        accessToken: {
            type: String,
            required: true,
        },
        namesPrefix: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: false,
        },
    },

    data() {
        return {
            autofill: null,
            minimap: null,

            addressSelected: !!this.value,

            addressLine1: this.value.addressLine1 || '',
            addressLine2: this.value.addressLine2 || '',
            town: this.value.town || '',
            zipCode: this.value.zipCode || '',
            state: this.value.state || '',
            country: this.value.country || '',
            countryCode: this.value.countryCode || '',
            latitude: this.value.latitude || null,
            longitude: this.value.longitude || null,
        };
    },

    mounted() {
        this.autofill = this.$refs.autofill;

        this.minimap = new MapboxAddressMinimap();
        this.minimap.accessToken = this.accessToken;
        this.minimap.canAdjustMarker = true;
        this.minimap.satelliteToggle = true;
        this.minimap.onSaveMarkerLocation = this.onSaveMarkerLocation;
        const minimapContainer = this.$refs.minimap;
        minimapContainer.appendChild(this.minimap);

        if (this.addressSelected) {
            this.minimap.feature = {
                "type": "Feature",
                "properties": {},
                "geometry": {
                    "type": "Point",
                    "coordinates": [
                        this.longitude,
                        this.latitude
                    ]
                }
            };
        }
    },

    methods: {
        resetFields() {
            this.addressSelected = false;

            this.addressLine1 = '';
            this.addressLine2 = '';
            this.town = '';
            this.zipCode = '';
            this.state = '';
            this.country = '';
            this.countryCode = '';
            this.latitude = null;
            this.longitude = null;
        },

        onAddressSelected(event) {
            const featureCollection = event.detail;

            if (!featureCollection || !featureCollection.features.length) {
                this.addressSelected = false;
                this.minimap.feature = null;
                return;
            }

            const feature = featureCollection.features[0];

            if (feature) {
                this.resetFields();

                this.minimap.feature = feature;
                this.addressSelected = true;

                if (feature && feature.geometry && feature.geometry.coordinates) {
                    this.longitude = feature.geometry.coordinates[0];
                    this.latitude = feature.geometry.coordinates[1];
                }
            }
        },

        onSaveMarkerLocation(location) {
            if (location && location.length) {
                this.longitude = location[0];
                this.latitude = location[1];
            }
        },
    }
}
</script>

<style scoped>
.minimap {
    position: relative;
    width: 360px;
    height: 240px;
}
</style>
